import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { PDP_ALTERNATE_FLOW_SELECTOR } from '../../utils/constants';
const useStyles = makeStyles()((theme) => ({
    buttonPrimary: {
        '&.MuiButtonBase-root': {
            color: theme.isFlyingFlowers ? colors.supplementary.white : colors.supplementary.black,
            backgroundColor: theme.isFlyingFlowers ? colors.wildExotic[500] : '#FFD814',
            '&:hover': {
                backgroundColor: theme.isFlyingFlowers ? colors.wildExotic[600] : '#FFCE12',
            },
            '&:focus-visible': {
                backgroundColor: theme.isFlyingFlowers ? colors.wildExotic[500] : '#FFD814',
                border: 'none',
                outline: '1px solid #000000',
                outlineOffset: '4px',
                borderRadius: '8px',
                boxShadow: 'none',
            },
            '&:active': {
                boxShadow: 'none',
                backgroundColor: theme.isFlyingFlowers ? colors.wildExotic[500] : '#FFD814',
            },
            '&:disabled': {
                color: colors.supplementary.black,
                backgroundColor: '#BDBDBD',
            },
        },
    },
    buttonSecondaryDark: {
        '&.MuiButtonBase-root': {
            color: colors.supplementary.white,
            backgroundColor: theme.isFlyingFlowers ? colors.cobalt[500] : colors.supplementary.black,
            '&:hover': {
                color: colors.supplementary.white,
                backgroundColor: theme.isFlyingFlowers ? colors.cobalt[600] : '#4F4F4F',
            },
            '&:focus-visible': {
                backgroundColor: theme.isFlyingFlowers ? colors.cobalt[500] : '#000',
                border: 'none',
                outline: '1px solid #000000',
                outlineOffset: '4px',
                boxShadow: 'none',
                borderRadius: '8px',
            },
            '&:active': {
                boxShadow: 'none',
                backgroundColor: theme.isFlyingFlowers ? colors.cobalt[500] : '#000000',
            },
            '&:disabled': {
                color: colors.supplementary.black,
                backgroundColor: '#BDBDBD',
            },
        },
    },
    buttonSecondaryLight: {
        '&.MuiButtonBase-root': {
            color: theme.isFlyingFlowers ? colors.cobalt[500] : colors.grey.grey7,
            backgroundColor: colors.supplementary.white,
            '&:hover': {
                color: theme.isFlyingFlowers ? colors.cobalt[600] : undefined,
                backgroundColor: theme.isFlyingFlowers ? colors.black[100] : colors.primary.gold1,
            },
            '&:focus-visible': {
                color: theme.isFlyingFlowers ? colors.cobalt[600] : undefined,
                backgroundColor: theme.isFlyingFlowers ? colors.black[100] : undefined,
            },
            '&:active': {
                boxShadow: 'none',
                backgroundColor: colors.grey.grey5,
            },
            '&:disabled': {
                color: theme.isFlyingFlowers ? colors.black[600] : colors.grey.grey7,
                backgroundColor: theme.isFlyingFlowers ? colors.black[200] : colors.grey.grey3,
            },
        },
    },
    buttonTertiaryDark: {
        '&.MuiButtonBase-root': {
            color: theme.isFlyingFlowers ? colors.wildExotic[500] : colors.grey.grey7,
            backgroundColor: colors.supplementary.white,
            '&:hover': {
                color: theme.isFlyingFlowers ? colors.wildExotic[600] : undefined,
                backgroundColor: theme.isFlyingFlowers ? colors.black[100] : '#F6F6F6',
            },
            '&:focus-visible': {
                color: theme.isFlyingFlowers ? colors.wildExotic[600] : undefined,
                backgroundColor: '#FFFFFF',
                border: 'none',
                outline: '1px solid #000000',
                outlineOffset: '4px',
                boxShadow: 'none',
                borderRadius: '8px',
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&:disabled': {
                color: '#000000',
                backgroundColor: '#BDBDBD',
            },
        },
    },
    buttonTertiaryLight: {
        '&.MuiButtonBase-root': {
            color: theme.isFlyingFlowers ? colors.plushBlush[400] : colors.supplementary.white,
            backgroundColor: colors.grey.grey7,
            borderColor: theme.isFlyingFlowers ? colors.plushBlush[400] : colors.supplementary.white,
            '&:hover': {
                color: theme.isFlyingFlowers ? colors.plushBlush[300] : colors.primary.gold1,
                borderColor: theme.isFlyingFlowers ? colors.plushBlush[300] : colors.primary.gold1,
            },
            '&:focus-visible': {
                color: theme.isFlyingFlowers ? colors.plushBlush[300] : colors.primary.gold1,
                backgroundColor: theme.isFlyingFlowers ? colors.supplementary.black : undefined,
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&:disabled': {
                color: theme.isFlyingFlowers ? colors.black[300] : colors.grey.grey4,
                backgroundColor: theme.isFlyingFlowers ? colors.black[600] : colors.grey.grey7,
                borderColor: theme.isFlyingFlowers ? colors.black[300] : colors.grey.grey4,
            },
        },
    },
    button: {
        textTransform: 'none',
        borderRadius: theme.isFlyingFlowers ? 8 : 4,
        '&:focus-visible': {
            outline: '1px solid #000000',
            outlineOffset: '4px',
            boxShadow: 'none',
        },
        '&:disabled': {
            boxShadow: theme.isFlyingFlowers ? 'none' : undefined,
        },
        // Expected height 60px
        '&.MuiButtonBase-root.MuiButton-root': {
            paddingTop: theme.isFlyingFlowers ? 16 : 20,
            paddingBottom: 20,
            paddingLeft: 25,
            paddingRight: 25,
            [`${PDP_ALTERNATE_FLOW_SELECTOR} &`]: {
                padding: theme.isFlyingFlowers ? `10px ${spacing.medium}` : `15px ${spacing.medium} 13px`,
            },
            '&.buttonTertiaryDark, &.buttonTertiaryLight': {
                paddingTop: theme.isFlyingFlowers ? 14 : 18,
                paddingBottom: 18,
                paddingLeft: 23,
                paddingRight: 23,
                border: `1px solid ${theme.isFlyingFlowers ? colors.wildExotic[500] : '#828282'}`,
                '&:disabled': {
                    borderWidth: '0',
                    borderStyle: 'none',
                    outline: 'none',
                },
            },
        },
        '&.MuiButton-root': {
            flexDirection: theme.isFlyingFlowers ? 'row-reverse' : undefined,
            '& .MuiButton-startIcon': {
                marginLeft: theme.isFlyingFlowers ? spacing.xxs : 0,
                marginRight: theme.isFlyingFlowers ? 0 : spacing.xxs,
                // Use margin to adjust icon to same height as text
                marginTop: theme.isFlyingFlowers ? undefined : -2,
                marginBottom: theme.isFlyingFlowers ? undefined : -2,
            },
        },
        '& .MuiButton-startIcon': {
            marginLeft: theme.isFlyingFlowers ? spacing.xxs : 0,
            marginRight: theme.isFlyingFlowers ? 0 : spacing.xxs,
            // Use margin to adjust icon to same height as text
            marginTop: theme.isFlyingFlowers ? undefined : -2,
            marginBottom: theme.isFlyingFlowers ? undefined : -2,
        },
        '& .MuiIcon-root': { fontSize: '1.5rem' },
    },
    buttonThin: {
        // Expected height 44px
        '&.MuiButtonBase-root.MuiButton-root': {
            paddingTop: theme.isFlyingFlowers ? 12 : 14,
            paddingBottom: theme.isFlyingFlowers ? 12 : 14,
            paddingLeft: 31,
            paddingRight: 31,
            '&.buttonTertiaryDark, &.buttonTertiaryLight': {
                paddingTop: theme.isFlyingFlowers ? 10 : 12,
                paddingBottom: theme.isFlyingFlowers ? 10 : 12,
                paddingLeft: 29,
                paddingRight: 29,
            },
            '& .MuiButton-startIcon': {
                // Use margin to adjust icon to same height as text
                marginTop: theme.isFlyingFlowers ? -2 : -4,
                marginBottom: theme.isFlyingFlowers ? -2 : -4,
            },
        },
        '& .labelSmall': Object.assign(Object.assign({}, theme.typography.small_button), { paddingTop: `0 !important` }),
    },
    buttonThinMobile: {
        // Duplicate of buttonThin but inside breakpoint
        [theme.breakpoints.down('sm')]: {
            // Expected height 44px
            '&.MuiButtonBase-root.MuiButton-root': {
                paddingTop: theme.isFlyingFlowers ? 12 : 14,
                paddingBottom: theme.isFlyingFlowers ? 12 : 14,
                paddingLeft: 31,
                paddingRight: 31,
                '&.buttonTertiaryDark, &.buttonTertiaryLight': {
                    paddingTop: theme.isFlyingFlowers ? 10 : 12,
                    paddingBottom: theme.isFlyingFlowers ? 10 : 12,
                    paddingLeft: 29,
                    paddingRight: 29,
                },
                '& .MuiButton-startIcon': {
                    // Use margin to adjust icon to same height as text
                    marginTop: theme.isFlyingFlowers ? -2 : -4,
                    marginBottom: theme.isFlyingFlowers ? -2 : -4,
                },
            },
            '& .labelSmall': Object.assign(Object.assign({}, theme.typography.small_button), { paddingTop: `0 !important` }),
        },
    },
    label: Object.assign({ display: 'block' }, theme.typography.medium_button),
    iconContainer: { color: 'inherit !important' },
    rippleClassPrimary: {
        color: colors.primary.gold2,
    },
    rippleClassSecondaryDark: {
        color: colors.grey.grey5,
    },
    spinner: {
        marginLeft: theme.isFlyingFlowers ? 0 : 5,
        marginRight: theme.isFlyingFlowers ? 5 : 0,
    },
    icon: {},
}));
export default useStyles;
